import React from 'react';

const FormDiv = (props) => {
    return ( 
        <div className='FormDiv'>
            <label className='FormLabel'>{props.label}</label>
            <input className='FormInput' type={props.type} placeholder={props.placeholder} value={props.value} onChange={props.onChange}  required />
        </div>
     );
}
 
export default FormDiv;